import(/* webpackMode: "eager" */ "/usr/src/app/src/app/error.js");
